import isEmpty from 'lodash/isEmpty'
import { FC, useEffect, useRef } from 'react'
import {
  Card,
  CardContent,
  CollapsibleTopicItem,
  Container,
  Col,
  Row,
  Section,
} from 'atoms'
import {
  ContactCard,
} from 'organisms'
import { useCollabsible } from 'services/Collapsible'
import FAQ from './FAQ'
import LgAnswer from './LgAnswer'
import LgQuestion from './LgQuestion'

const FragenAntworten: FC<unknown> = () => {
  const { uncollapse, group } = useCollabsible('faqLg')
  const groupRef = useRef(group)

  useEffect(() => {
    if (!isEmpty(groupRef?.current)) return
    groupRef.current = group
    uncollapse('0')
  }, [uncollapse, group])

  return (
    <>
      <Section background="vintage">
        <Container>
          <h1>
            Fragen und Antworten
          </h1>
          <Card className="mb-4">
            <CardContent className='mt-3 d-block d-lg-none'>
              {FAQ.map((item, index) => (
                <CollapsibleTopicItem
                  groupId="faq"
                  key={`${index}`}
                  id={`${index}`}
                  label={item.question}
                  labelAs="h2"
                  content={item.content}
                />
              ))}
            </CardContent>
            <CardContent className="d-none d-lg-block">
              <Row>
                <Col md={4}>
                  <nav>
                    {FAQ.map((item, index) => (
                      <LgQuestion
                        groupId="faqLg"
                        key={`${index}`}
                        id={`${index}`}
                        item={item}
                      />
                    ))}
                  </nav>
                </Col>
                <Col md={8}>
                  {FAQ.map((item, index) => (
                    <LgAnswer
                      groupId="faqLg"
                      key={`${index}`}
                      id={`${index}`}
                      item={item}
                    />
                  ))}
                </Col>
              </Row>
            </CardContent>
          </Card>
          <ContactCard />
        </Container>
      </Section>
    </>
  )
}

export default FragenAntworten
